import React, { useEffect, useState } from 'react'
import { Icon } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { palette } from 'styles/colors'
import { useHistory, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getUser } from 'redux/selectors/auth'
import { getCurrentUser } from 'redux/modules/auth/actions'
import { ReactComponent as DashboardIcon } from '../assets/menu/dashboard.svg'
import { ReactComponent as NotificationsIcon } from '../assets/menu/bell.svg'
import { ReactComponent as SpecialistsIcon } from '../assets/menu/specialits.svg'
import { ReactComponent as PatientsIcon } from '../assets/menu/patients.svg'
import { ReactComponent as ClinicsIcon } from '../assets/menu/clinics.svg'
import { ReactComponent as PharmaciesIcon } from '../assets/menu/pharmacies.svg'
import { ReactComponent as ModeratorsIcon } from '../assets/menu/moderators.svg'
import { ReactComponent as ReceptionsIcon } from '../assets/menu/receptions.svg'
import { ReactComponent as SecondOpinionIcon } from '../assets/menu/secondOpinion.svg'
import { ReactComponent as PromocodeIcon } from '../assets/menu/promocode.svg'
import { ReactComponent as OpenMenuIcon } from '../assets/menu/openMenu.svg'
import { ReactComponent as HideMenuIcon } from '../assets/menu/hideMenu.svg'
import { ReactComponent as LogoutIcon } from '../assets/menu/logout.svg'

const Menu = ({ classes }) => {
  const menuItems = [
    {
      title: 'Дашбоард',
      route: '/dashboard',
      icon: <DashboardIcon />
    },
    {
      title: 'Уведомления',
      route: '/notifications',
      icon: <NotificationsIcon />
    },
    {
      title: 'Специалисты',
      route: '/specialists',
      icon: <SpecialistsIcon />
    },
    {
      title: 'Пациенты',
      route: '/patients',
      icon: <PatientsIcon />
    },
    {
      title: 'Клиники',
      route: '/clinics',
      icon: <ClinicsIcon />
    },
    {
      title: 'Аптека',
      route: '/pharmacies',
      icon: <PharmaciesIcon />
    },
    {
      title: 'Модераторы',
      route: '/moderators',
      icon: <ModeratorsIcon />
    },
    // {
    //   title: 'Абонементы',
    //   route: '/subscriptions'
    // },
    // {
    //   title: 'Вывод средств',
    //   route: '/cash-requests'
    // },
    {
      title: 'Приемы',
      route: '/receptions',
      icon: <ReceptionsIcon />
    },
    {
      title: 'Второе мнение',
      route: '/second-opinion',
      icon: <SecondOpinionIcon />
    },
    {
      title: 'Промокоды',
      route: '/promocodes',
      icon: <PromocodeIcon />
    }
  ]

  const menuItemsCall = [
    {
      title: 'Дашбоард',
      route: '/dashboard',
      icon: <DashboardIcon />
    },
    {
      title: 'Пациенты',
      route: '/patients',
      icon: <PatientsIcon />
    },
    {
      title: 'Приемы',
      route: '/receptions',
      icon: <ReceptionsIcon />
    },
    {
      title: 'Второе мнение',
      route: '/second-opinion',
      icon: <SecondOpinionIcon />
    }
  ]

  const menuItemsModerator = [
    {
      title: 'Дашбоард',
      route: '/dashboard',
      icon: <DashboardIcon />
    },
    {
      title: 'Специалисты',
      route: '/specialists',
      icon: <SpecialistsIcon />
    },
    {
      title: 'Пациенты',
      route: '/patients',
      icon: <PatientsIcon />
    },
    {
      title: 'Клиники',
      route: '/clinics',
      icon: <ClinicsIcon />
    },
    {
      title: 'Аптеки',
      route: '/pharmacies',
      icon: <PharmaciesIcon />
    }
  ]

  const location = useLocation()
  const router = useHistory()
  const dispatch = useDispatch()

  const logout = () => {
    localStorage.JWT_KEY = null
    router.push('/')
  }

  const user = useSelector(getUser)

  useEffect(() => {
    dispatch(getCurrentUser())
  }, [])

  const [isOpenFullMenu, setIsOpenFullMenu] = useState(() => {
    const saved = localStorage.getItem('menu_is_open')
    return saved === null ? true : saved === 'true'
  })

  const toggleMenu = () => {
    const newState = !isOpenFullMenu
    setIsOpenFullMenu(newState)
    localStorage.setItem('menu_is_open', String(newState))
  }

  return (
    <div
      className={`${classes.wrapper} ${
        !isOpenFullMenu ? classes.wrapperSmall : ''
      }`}
    >
      <div className={classes.header}>
        <div onClick={toggleMenu} className={classes.menuIcon}>
          {isOpenFullMenu ? <HideMenuIcon /> : <OpenMenuIcon />}
        </div>
        <div className={classes.menuItems}>
          {user && user.status === 'admin' ? (
            <>
              {menuItems.map((item) => (
                <div
                  key={item.title}
                  onClick={() => router.push(item.route)}
                  className={`${classes.item} 
              ${!isOpenFullMenu ? classes.itemSmall : ''} 
              ${location.pathname === item.route ? classes.activeItem : ''}`}
                >
                  {item.icon}
                  {isOpenFullMenu && (
                    <p className={classes.itemText}>{item.title}</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
          {user && user.status === 'call' ? (
            <>
              {menuItemsCall.map((item) => (
                <div
                  key={item.title}
                  onClick={() => router.push(item.route)}
                  className={`${classes.item} 
              ${!isOpenFullMenu ? classes.itemSmall : ''} 
              ${location.pathname === item.route ? classes.activeItem : ''}`}
                >
                  {item.icon}
                  {isOpenFullMenu && (
                    <p className={classes.itemText}>{item.title}</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
          {user && user.status === 'moderator' ? (
            <>
              {menuItemsModerator.map((item) => (
                <div
                  key={item.title}
                  onClick={() => router.push(item.route)}
                  className={`${classes.item} 
              ${!isOpenFullMenu ? classes.itemSmall : ''} 
              ${location.pathname === item.route ? classes.activeItem : ''}`}
                >
                  {item.icon}
                  {isOpenFullMenu && (
                    <p className={classes.itemText}>{item.title}</p>
                  )}
                </div>
              ))}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className={classes.logout} onClick={logout}>
        <LogoutIcon />
        {isOpenFullMenu && <p className={classes.logoutText}>Выход</p>}
      </div>
    </div>
  )
}

const styles = () => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 260, // вместо 18%
    minWidth: 260,
    minHeight: '100vh',
    backgroundColor: palette.backdrop,
    justifyContent: 'space-between',
    zIndex: 1,
    flexShrink: 0, // важно: не даём сжимать колонку
    boxSizing: 'border-box'
  },
  wrapperSmall: {
    width: 72, // вместо 3%
    minWidth: 72
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  menuIcon: {
    alignSelf: 'flex-end',
    margin: '1em 1em 0em 0em'
  },
  menuItems: {
    marginTop: '1em',
    width: '100%'
  },
  item: {
    color: palette.white,
    fontSize: '1.1em',
    margin: '1em 0',
    padding: '0.5em 2em',
    '&:hover': {
      cursor: 'pointer'
    },
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      flexShrink: 0
    }
  },
  itemSmall: {
    paddingLeft: '1em',
    paddingRight: '1em',
    justifyContent: 'center' // чтобы иконка стояла красиво по центру
  },
  itemText: {
    padding: '0 0.5em 0 0.5em'
  },
  activeItem: {
    backgroundColor: palette.blueLight
  },
  logout: {
    marginBottom: '2em',
    backgroundColor: palette.blueLight,
    width: '100%',
    padding: '0.5em 0',
    '&:hover': {
      cursor: 'pointer'
    },
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  logoutText: {
    color: palette.white,
    marginLeft: '0.5em',
    fontSize: '1.3em'
  }
})

export default withStyles(styles)(Menu)
